import { InputNumber } from 'antd'
import type { SchemeAccounting } from '~/gql/generated/graphql'

const DEFAULT_CURRENCY = 'gbp'

export const CurrencyInput = ({
  currency,
  ...props
}: React.ComponentProps<typeof InputNumber> & {
  currency?: SchemeAccounting['currency']
}) => {
  const currencySymbol = { gbp: '£', usd: '$', eur: '€' }[
    currency ?? DEFAULT_CURRENCY
  ]

  return (
    <InputNumber
      min={0}
      step={0.1}
      addonBefore={currencySymbol}
      precision={2}
      {...props}
    />
  )
}

export const MinuteInput = (
  props: React.ComponentProps<typeof InputNumber<number>>,
) => {
  return (
    <InputNumber<number>
      min={0}
      step={1}
      addonAfter="mins"
      style={{ width: '120px' }}
      {...props}
    />
  )
}
